export const DOMAIN = 'auth.customer.dsar.stats';
